<template>
  <div>
    <div class="container z-10">
      <h1 class="mt-12 fluid-xl leading-tight font-medium">{{ category.title }}</h1>
    </div>
    <div class="mt-9 container flex flex-row justify-end">
      <span class="font-medium">{{ $t('knowledge.articlesCount', { count: articles.length }) }}</span>
    </div>
    <div class="2xl:p-0 container">
      <ArticleList :articles="articles" class="mt-12" />
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import topicPage from '@/mixins/topicPage';
import knowlegdeCategoryPage, { RelatedArticlesQuery, KnowledgeCategoryFragment } from '@/mixins/knowledgeCategoryPage';
import { SeomaticFragment } from '@/mixins/entryPage';
import { stripLocale } from '@/utils/i18n';
import ArticleList from '@/components/article/ArticleList';

const KnowlegdeCategoryQuery = gql`
  query KnowlegdeCategoryQuery($site: String!, $uri: String!, $category: String!) {
    seomatic(site: $site, uri: $uri, asArray: true) {
      ...SeomaticFragment
    }
    entry(site: [$site], section: "knowledgeCategories", slug: [$category]) {
      ...KnowledgeCategoryFragment
    }
  }
  ${KnowledgeCategoryFragment}
  ${SeomaticFragment}
`;
export default defineNuxtComponent({
  name: 'CategoryPage',

  components: { ArticleList },

  mixins: [topicPage, knowlegdeCategoryPage],

  async asyncData() {
    const { $craftRequest } = useNuxtApp();
    const route = useRoute();
    const { locale } = useNuxtApp().$i18n;

    const categorySlug = route.params.slug;

    const uri = stripLocale(route.path, locale.value);

    const variables = { site: locale.value, category: categorySlug, uri };

    const { entry, seomatic } = await $craftRequest(KnowlegdeCategoryQuery, variables);

    const relatedVariables = { site: locale.value, related: [entry.id] };
    const { entries: articles } = await $craftRequest(RelatedArticlesQuery, relatedVariables);

    return { entry, category: entry, articles, seomatic };
  },

  data() {
    return {
      category: null,
    };
  },

  mounted() {
    this.$emit('onAllCategories');
    this.gtmPushPageMeta({ content_category: 'knowledge', content_subcategory: this.entry?.slug });
  },
});
</script>
